// import React, { useMemo, useState } from "react";
// import {
//   Bar,
//   CartesianGrid,
//   ComposedChart,
//   Line,
//   Pie,
//   PieChart,
//   ResponsiveContainer,
//   Tooltip,
//   XAxis,
//   YAxis,
//   Cell,
// } from "recharts";
// import {
//   AlertTriangle,
//   Building2,
//   ChevronDown,
//   GraduationCap,
//   Moon,
//   Sun,
//   Target,
//   TrendingDown,
//   Users,
//   Wallet,
// } from "lucide-react";

// const colors = {
//   blue: "#3975d7",
//   teal: "#079b83",
//   green: "#1a9b62",
//   amber: "#cf861c",
//   red: "#dc4c42",
//   violet: "#7154d8",
// };

// const campuses = [
//   {
//     id: "ind",
//     name: "Indiranagar",
//     students: [1240, 1152],
//     teachers: [68, 64],
//     staff: [42, 39],
//     revenue: 842,
//     pass: [91.2, 94.6],
//     admissions: [260, 612, 348, 214],
//     fees: [
//       ["Apr", 210, 198],
//       ["May", 160, 149],
//       ["Jun", 165, 151],
//       ["Jul", 170, 158],
//       ["Aug", 175, 121],
//     ],
//     mix: [588, 118, 76, 60],
//   },
//   {
//     id: "wtf",
//     name: "Whitefield",
//     students: [1685, 1521],
//     teachers: [92, 85],
//     staff: [55, 51],
//     revenue: 1186,
//     pass: [88.4, 90.1],
//     admissions: [320, 780, 431, 287],
//     fees: [
//       ["Apr", 300, 291],
//       ["May", 225, 214],
//       ["Jun", 230, 221],
//       ["Jul", 235, 226],
//       ["Aug", 240, 178],
//     ],
//     mix: [812, 176, 118, 80],
//   },
//   {
//     id: "jay",
//     name: "Jayanagar",
//     students: [980, 941],
//     teachers: [54, 52],
//     staff: [34, 33],
//     revenue: 612,
//     pass: [93.5, 92.8],
//     admissions: [200, 445, 276, 188],
//     fees: [
//       ["Apr", 150, 147],
//       ["May", 115, 112],
//       ["Jun", 118, 116],
//       ["Jul", 120, 117],
//       ["Aug", 122, 104],
//     ],
//     mix: [436, 82, 52, 42],
//   },
//   {
//     id: "heb",
//     name: "Hebbal",
//     students: [1120, 1004],
//     teachers: [61, 55],
//     staff: [38, 34],
//     revenue: 705,
//     pass: [85.1, 89.3],
//     admissions: [240, 502, 298, 171],
//     fees: [
//       ["Apr", 180, 152],
//       ["May", 135, 108],
//       ["Jun", 138, 111],
//       ["Jul", 142, 116],
//       ["Aug", 145, 89],
//     ],
//     mix: [486, 104, 64, 51],
//   },
//   {
//     id: "ecy",
//     name: "Electronic City",
//     students: [1435, 1350],
//     teachers: [78, 74],
//     staff: [47, 45],
//     revenue: 934,
//     pass: [89.9, 93.2],
//     admissions: [300, 688, 402, 259],
//     fees: [
//       ["Apr", 235, 228],
//       ["May", 178, 169],
//       ["Jun", 182, 174],
//       ["Jul", 186, 176],
//       ["Aug", 190, 141],
//     ],
//     mix: [648, 138, 86, 62],
//   },
// ];

// const sum = (items, getValue) =>
//   items.reduce((total, item) => total + getValue(item), 0);
// const rate = (value, total) =>
//   total ? Math.round((value / total) * 1000) / 10 : 0;
// const number = (value) => Math.round(value).toLocaleString("en-IN");
// const money = (lakhs) =>
//   lakhs >= 100
//     ? `Rs. ${(lakhs / 100).toFixed(2)} Cr`
//     : `Rs. ${Math.round(lakhs)} L`;

// function getGroup() {
//   const fees = campuses[0].fees.map((fee, index) => ({
//     month: fee[0],
//     target: sum(campuses, (campus) => campus.fees[index][1]),
//     collected: sum(campuses, (campus) => campus.fees[index][2]),
//   }));
//   return {
//     id: "all",
//     name: "All Schools",
//     students: [
//       sum(campuses, (campus) => campus.students[0]),
//       sum(campuses, (campus) => campus.students[1]),
//     ],
//     teachers: [
//       sum(campuses, (campus) => campus.teachers[0]),
//       sum(campuses, (campus) => campus.teachers[1]),
//     ],
//     staff: [
//       sum(campuses, (campus) => campus.staff[0]),
//       sum(campuses, (campus) => campus.staff[1]),
//     ],
//     revenue: sum(campuses, (campus) => campus.revenue),
//     pass: [
//       sum(campuses, (campus) => campus.pass[0] * campus.students[0]) /
//         sum(campuses, (campus) => campus.students[0]),
//       sum(campuses, (campus) => campus.pass[1] * campus.students[0]) /
//         sum(campuses, (campus) => campus.students[0]),
//     ],
//     admissions: [0, 1, 2, 3].map((index) =>
//       sum(campuses, (campus) => campus.admissions[index]),
//     ),
//     fees,
//     mix: [0, 1, 2, 3].map((index) =>
//       sum(campuses, (campus) => campus.mix[index]),
//     ),
//   };
// }

// function Card({ children, style }) {
//   return (
//     <section className="overall-card" style={style}>
//       {children}
//     </section>
//   );
// }
// function Heading({ eyebrow, children, extra }) {
//   return (
//     <div className="overall-heading">
//       <div>
//         <small>{eyebrow}</small>
//         <h2>{children}</h2>
//       </div>
//       {extra}
//     </div>
//   );
// }
// function Metric({ icon: Icon, label, value, hint, color }) {
//   return (
//     <Card>
//       <div className="metric-icon" style={{ background: color }}>
//         <Icon size={20} />
//       </div>
//       <strong className="metric-value">{value}</strong>
//       <div className="metric-label">{label}</div>
//       <p>{hint}</p>
//     </Card>
//   );
// }

// export default function OverallDashboard() {
//   const [selected, setSelected] = useState("all");
//   const [dark, setDark] = useState(false);
//   const group = useMemo(getGroup, []);
//   const view =
//     selected === "all"
//       ? group
//       : campuses.find((campus) => campus.id === selected);
//   const fees = view.fees[0].month
//     ? view.fees
//     : view.fees.map(([month, target, collected]) => ({
//         month,
//         target,
//         collected,
//       }));
//   const feeTarget = sum(fees, (fee) => fee.target);
//   const feeCollected = sum(fees, (fee) => fee.collected);
//   const collectionRate = rate(feeCollected, feeTarget);
//   const seatsFilled = rate(view.admissions[3], view.admissions[0]);
//   const attendance = rate(view.students[1], view.students[0]);
//   const alerts = campuses.filter(
//     (campus) =>
//       rate(
//         sum(campus.fees, (fee) => fee[2]),
//         sum(campus.fees, (fee) => fee[1]),
//       ) < 80 || campus.pass[1] < campus.pass[0],
//   );
//   const mixData = ["Tuition", "Transport", "Hostel", "Activities"].map(
//     (name, index) => ({ name, value: view.mix[index] }),
//   );

//   return (
//     <main className={`overall-dashboard ${dark ? "overall-dark" : ""}`}>
//       <style>{`
//       .overall-dashboard { --bg:#f4f6f9; --card:#ffffff; --ink:#11253d; --text:#3f5269; --muted:#718198; --line:#e7ebf1; min-height:100vh; width:100vw; margin-left:calc(50% - 50vw); padding:8px 40px 24px; background:var(--bg); color:var(--text); font-family:Arial,sans-serif; }
//       .overall-dark { --bg:#0b1729; --card:#12213a; --ink:#f2f6fc; --text:#d4dfed; --muted:#9caec5; --line:#263853; }
//       .overall-wrap { width:100%; max-width:none; margin:0; }.overall-toolbar,.overall-hero,.overall-heading,.overall-alert { display:flex; align-items:center; justify-content:space-between; gap:16px; }.overall-toolbar { margin-bottom:12px; }.overall-brand { display:flex; align-items:center; gap:10px; color:var(--ink); font-weight:700; }.overall-brand svg { padding:8px; width:38px; height:38px; color:#fff; background:#3975d7; border-radius:8px; }.overall-toolbar select,.overall-toolbar button { border:1px solid var(--line); border-radius:7px; padding:10px 12px; background:var(--card); color:var(--ink); font:600 13px Arial; }.overall-toolbar button { display:grid; place-items:center; cursor:pointer; padding:10px; }.overall-hero { padding:28px; border-radius:8px; color:#fff; background:linear-gradient(115deg,#133562,#356ec8,#088b7e); }.overall-hero h1 { margin:5px 0; font-size:30px; }.overall-hero p { margin:0; color:#e7f0ff; }.overall-live { font-size:11px; font-weight:700; letter-spacing:.08em; }.overall-live::before { content:""; display:inline-block; width:7px; height:7px; margin-right:6px; border-radius:50%; background:#7ef1c5; }.overall-hero-stats { display:flex; gap:28px; text-align:right; }.overall-hero-stats strong { display:block; font-size:23px; }.overall-grid { display:grid; gap:14px; margin-top:14px; }.overall-kpis { grid-template-columns:repeat(4,1fr); }.overall-main { grid-template-columns:1.1fr 1.4fr; }.overall-bottom { grid-template-columns:1fr 1.3fr; }
//       .overall-card { padding:20px; border:none; box-shadow:0 .5rem 1rem rgba(0,0,0,.08); border-radius:10px; background:var(--card); min-width:0; }
//       .metric-icon { display:grid; place-items:center; width:40px; height:40px; color:#fff; border-radius:8px; }.metric-value { display:block; margin-top:15px; font-size:27px; color:var(--ink); }.metric-label { margin-top:4px; color:var(--text); font-weight:700; font-size:13px; }.overall-card p { margin:7px 0 0; color:var(--muted); font-size:12px; line-height:1.45; }.overall-heading { align-items:flex-start; }.overall-heading small { color:var(--muted); font-size:10px; font-weight:700; letter-spacing:.12em; }.overall-heading h2 { margin:4px 0 0; color:var(--ink); font-size:18px; }.overall-rings { display:flex; justify-content:space-around; gap:12px; margin-top:25px; }.overall-ring { text-align:center; }.overall-ring strong { display:grid; place-items:center; width:94px; height:94px; margin:auto; border:9px solid #3975d7; border-radius:50%; color:var(--ink); font-size:21px; background:var(--card); }.overall-ring:nth-child(2) strong { border-color:#079b83; }.overall-ring:nth-child(3) strong { border-color:#cf861c; }.overall-ring span { display:block; margin-top:8px; font-size:12px; font-weight:700; color:var(--text); }.overall-chart { height:270px; margin-top:12px; }.overall-funnel { margin-top:20px; }.overall-funnel-row { margin:13px 0; }.overall-funnel-row div { display:flex; justify-content:space-between; font-size:13px; font-weight:700; color:var(--ink); }.overall-funnel-row i { display:block; height:11px; margin-top:6px; border-radius:6px; background:#e5ebf3; overflow:hidden; }.overall-funnel-row b { display:block; height:100%; border-radius:6px; }.overall-table { width:100%; margin-top:12px; border-collapse:collapse; font-size:13px; }.overall-table th,.overall-table td { padding:11px 8px; border-bottom:1px solid var(--line); text-align:right; }.overall-table th { color:var(--muted); font-size:10px; letter-spacing:.08em; }.overall-table th:nth-child(2),.overall-table td:nth-child(2) { text-align:left; }.overall-table td { color:var(--text); }.overall-table td:nth-child(2) { color:var(--ink); font-weight:700; }.overall-alert { margin-top:14px; padding:14px 16px; border-left:4px solid #cf861c; border-radius:6px; background:#fff5df; color:#704c10; }.overall-dark .overall-alert { background:#3c301b; color:#ffe2a1; }.overall-alert div { display:flex; gap:10px; align-items:center; font-size:13px; }.overall-alert strong { color:inherit; }

//       @media (max-width:992px) {
//         .overall-main, .overall-bottom { grid-template-columns:1fr !important; }
//         .overall-kpis { grid-template-columns:repeat(2,1fr) !important; }
//         .overall-dashboard { padding:15px 24px !important; }
//         .overall-hero-stats { gap:15px !important; }
//         .overall-card { width:100% !important; }
//       }

//       @media (max-width:768px) {
//         .overall-toolbar, .overall-hero { flex-direction:column !important; align-items:flex-start !important; }
//         .overall-toolbar select, .overall-toolbar button { width:100% !important; }
//         .overall-hero-stats { width:100% !important; justify-content:space-between !important; text-align:left !important; }
//         .overall-dashboard { padding:15px 18px !important; }
//         .overall-card { padding:15px !important; }
//         .overall-table { font-size:12px !important; }
//         .overall-table .overall-table { overflow-x:auto !important; }
//       }

//       @media (max-width:576px) {
//         .overall-dashboard { padding:10px 12px !important; }
//         .overall-kpis { grid-template-columns:1fr !important; }
//         .overall-hero h1 { font-size:22px !important; }
//         .overall-rings { flex-wrap:wrap !important; }
//         .overall-ring strong { width:80px !important; height:80px !important; font-size:17px !important; }
//         .metric-value { font-size:22px !important; }
//         .overall-table th, .overall-table td { padding:8px 6px !important; font-size:.85rem !important; }
//       }
//     `}</style>
//       <div className="overall-wrap">
//         <header className="overall-toolbar">
//           <div className="overall-brand">
//             <GraduationCap /> Greenwood High{" "}
//             <span style={{ color: "var(--muted)", fontWeight: 400 }}>
//               | Overall Dashboard
//             </span>
//           </div>
//           <div style={{ display: "flex", gap: 8 }}>
//             <select
//               value={selected}
//               onChange={(event) => setSelected(event.target.value)}
//               aria-label="Select campus"
//             >
//               <option value="all">All schools (group)</option>
//               {campuses.map((campus) => (
//                 <option key={campus.id} value={campus.id}>
//                   {campus.name} Campus
//                 </option>
//               ))}
//             </select>
//             <button
//               type="button"
//               onClick={() => setDark(!dark)}
//               aria-label="Toggle dashboard color mode"
//             >
//               {dark ? <Sun size={18} /> : <Moon size={18} />}
//             </button>
//           </div>
//         </header>
//         <section className="overall-hero">
//           <div>
//             <div className="overall-live">LIVE OVERVIEW</div>
//             <h1>
//               {selected === "all"
//                 ? "Group performance, at a glance"
//                 : `${view.name} Campus`}
//             </h1>
//             <p>
//               Academic year 2026-27 | Attendance, fees, admissions and academic
//               outcomes
//             </p>
//           </div>
//           <div className="overall-hero-stats">
//             <div>
//               <strong>{selected === "all" ? 5 : 1}</strong>Campuses
//             </div>
//             <div>
//               <strong>
//                 {number(view.students[1] + view.teachers[1] + view.staff[1])}
//               </strong>
//               People on site
//             </div>
//             <div>
//               <strong>{seatsFilled}%</strong>Seats filled
//             </div>
//           </div>
//         </section>
//         <section className="overall-grid overall-kpis">
//           <Metric
//             icon={Users}
//             color={colors.blue}
//             label="Students on roll"
//             value={number(view.students[0])}
//             hint={`${number(view.students[1])} present today`}
//           />
//           <Metric
//             icon={Wallet}
//             color={colors.teal}
//             label="Revenue YTD"
//             value={money(view.revenue)}
//             hint="All fee heads combined"
//           />
//           <Metric
//             icon={Target}
//             color={colors.amber}
//             label="Fee collection rate"
//             value={`${collectionRate}%`}
//             hint={`${money(feeTarget - feeCollected)} outstanding`}
//           />
//           <Metric
//             icon={GraduationCap}
//             color={colors.violet}
//             label="Pass rate"
//             value={`${view.pass[1].toFixed(1)}%`}
//             hint={`${view.pass[1] >= view.pass[0] ? "+" : ""}${(view.pass[1] - view.pass[0]).toFixed(1)} pts year-on-year`}
//           />
//         </section>
//         <section className="overall-grid overall-main">
//           <Card>
//             <Heading eyebrow="ATTENDANCE | TODAY">Who's on campus</Heading>
//             <div className="overall-rings">
//               {[
//                 ["Students", view.students, colors.blue],
//                 ["Teachers", view.teachers, colors.teal],
//                 ["Support staff", view.staff, colors.amber],
//               ].map(([label, people]) => (
//                 <div className="overall-ring" key={label}>
//                   <strong>{rate(people[1], people[0])}%</strong>
//                   <span>{label}</span>
//                   <p>
//                     {number(people[1])}/{number(people[0])} present
//                   </p>
//                 </div>
//               ))}
//             </div>
//           </Card>
//           <Card>
//             <Heading
//               eyebrow="TUITION FEES | MONTHLY"
//               extra={<small>Rs. lakh</small>}
//             >
//               Collection vs billed target
//             </Heading>
//             <div className="overall-chart">
//               <ResponsiveContainer>
//                 <ComposedChart data={fees}>
//                   <CartesianGrid
//                     stroke="var(--line)"
//                     strokeDasharray="3 3"
//                     vertical={false}
//                   />
//                   <XAxis
//                     dataKey="month"
//                     tick={{ fill: "var(--muted)", fontSize: 12 }}
//                   />
//                   <YAxis tick={{ fill: "var(--muted)", fontSize: 12 }} />
//                   <Tooltip formatter={(value) => [`Rs. ${number(value)} L`]} />
//                   <Bar
//                     dataKey="collected"
//                     fill={colors.teal}
//                     radius={[5, 5, 0, 0]}
//                   />
//                   <Line
//                     dataKey="target"
//                     stroke={colors.blue}
//                     strokeWidth={2.5}
//                   />
//                 </ComposedChart>
//               </ResponsiveContainer>
//             </div>
//           </Card>
//         </section>
//         <section className="overall-grid overall-bottom">
//           <Card>
//             <Heading eyebrow="ADMISSIONS | AY 2026-27">
//               Enquiry to enrolment
//             </Heading>
//             <div className="overall-funnel">
//               {[
//                 ["Enquiries", view.admissions[1], colors.blue],
//                 ["Applications", view.admissions[2], colors.violet],
//                 ["Admitted", view.admissions[3], colors.green],
//               ].map(([label, value, color]) => (
//                 <div className="overall-funnel-row" key={label}>
//                   <div>
//                     <span>{label}</span>
//                     <span>{number(value)}</span>
//                   </div>
//                   <i>
//                     <b
//                       style={{
//                         width: `${rate(value, view.admissions[1])}%`,
//                         background: color,
//                       }}
//                     />
//                   </i>
//                 </div>
//               ))}
//             </div>
//             <p>
//               <strong>{seatsFilled}%</strong> of the{" "}
//               {number(view.admissions[0])} seat target is filled.
//             </p>
//           </Card>
//           <Card>
//             <Heading eyebrow="FINANCE">Revenue mix by fee head</Heading>
//             <div className="overall-chart">
//               <ResponsiveContainer>
//                 <PieChart>
//                   <Pie
//                     data={mixData}
//                     dataKey="value"
//                     nameKey="name"
//                     innerRadius={55}
//                     outerRadius={90}
//                     paddingAngle={3}
//                   >
//                     {mixData.map((item, index) => (
//                       <Cell
//                         key={item.name}
//                         fill={
//                           [
//                             colors.blue,
//                             colors.teal,
//                             colors.violet,
//                             colors.amber,
//                           ][index]
//                         }
//                       />
//                     ))}
//                   </Pie>
//                   <Tooltip formatter={(value) => money(value)} />
//                 </PieChart>
//               </ResponsiveContainer>
//             </div>
//           </Card>
//         </section>
//         <section className="overall-grid">
//           <Card>
//             <Heading eyebrow="CAMPUS LEADERBOARD">
//               Branch-by-branch report
//             </Heading>
//             <div style={{ overflowX: "auto" }}>
//               <table className="overall-table">
//                 <thead>
//                   <tr>
//                     <th>Campus</th>
//                     <th>Students</th>
//                     <th>Attendance</th>
//                     <th>Revenue</th>
//                     <th>Fees</th>
//                     <th>Pass delta</th>
//                     <th>Seats</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {campuses.map((campus) => {
//                     const campusFees = rate(
//                       sum(campus.fees, (fee) => fee[2]),
//                       sum(campus.fees, (fee) => fee[1]),
//                     );
//                     return (
//                       <tr key={campus.id}>
//                         <td>{campus.name}</td>
//                         <td>{number(campus.students[0])}</td>
//                         <td>{rate(campus.students[1], campus.students[0])}%</td>
//                         <td>{money(campus.revenue)}</td>
//                         <td>{campusFees}%</td>
//                         <td
//                           style={{
//                             color:
//                               campus.pass[1] >= campus.pass[0]
//                                 ? colors.green
//                                 : colors.red,
//                           }}
//                         >
//                           {(campus.pass[1] - campus.pass[0]).toFixed(1)}
//                         </td>
//                         <td>
//                           {rate(campus.admissions[3], campus.admissions[0])}%
//                         </td>
//                       </tr>
//                     );
//                   })}
//                 </tbody>
//               </table>
//             </div>
//           </Card>
//         </section>
//         {alerts.length > 0 && (
//           <section className="overall-alert">
//             <div>
//               <AlertTriangle size={19} />
//               <span>
//                 <strong>Management attention:</strong>{" "}
//                 {alerts.map((campus) => campus.name).join(", ")} need review for
//                 fee collection or year-on-year pass rate.
//               </span>
//             </div>
//             <TrendingDown size={19} />
//           </section>
//         )}
//       </div>
//     </main>
//   );
// }


import React, { useEffect, useMemo, useRef, useState } from "react";
import {
  ComposedChart, Bar, Line, XAxis, YAxis, CartesianGrid, Tooltip,
  ResponsiveContainer, PieChart, Pie, Cell,
} from "recharts";
import {
  Sun, Moon, ChevronDown, Users, Wallet, Target, GraduationCap,
  AlertTriangle, TrendingDown, Clock, Building2, Sparkles,
} from "lucide-react";

/* ═══════════════════════════════════════════════════════════════
   VIDYARNA GROUP · EXECUTIVE COMMAND CENTER  (v2)
   Multi-branch education dashboard · AY 2026-27
   ═══════════════════════════════════════════════════════════════ */

const THEMES = {
  light: {
    name: "light",
    bg: "#EDF1F6",
    bgGlow1: "rgba(59,111,224,.10)", bgGlow2: "rgba(16,185,129,.08)",
    card: "#FFFFFF", cardBorder: "#DFE6EE",
    ink: "#0E1F38", text: "#25334A", muted: "#5D6E85", faint: "#8C9BB0",
    hair: "#E3E9F0", trackBg: "#EDF1F6",
    headerBg: "rgba(255,255,255,.75)",
    heroText: "#FFFFFF",
    tooltipBg: "#FFFFFF",
    rowHover: "#F3F6FA", theadBg: "#F7F9FC",
    shadow: "0 14px 34px rgba(14,31,56,.10)",
  },
  dark: {
    name: "dark",
    bg: "#0B1322",
    bgGlow1: "rgba(91,141,239,.14)", bgGlow2: "rgba(45,212,191,.10)",
    card: "#101B30", cardBorder: "#1E2C47",
    ink: "#F1F6FD", text: "#D6E0EF", muted: "#93A4BD", faint: "#67788F",
    hair: "#1E2C47", trackBg: "#182540",
    headerBg: "rgba(11,19,34,.72)",
    heroText: "#FFFFFF",
    tooltipBg: "#16233C",
    rowHover: "#15223A", theadBg: "#0E1930",
    shadow: "0 16px 40px rgba(0,0,0,.42)",
  },
};

const ACC = {
  cobalt: "#4A7DF0", cobaltDeep: "#2B5AD0",
  teal: "#14B8A0", green: "#22B573",
  amber: "#E9A23B", red: "#EF5A4C", violet: "#8B5CF6",
};
const BRANCH_COLORS = [ACC.cobalt, ACC.teal, ACC.amber, ACC.red, ACC.violet];

/* ── Data ─────────────────────────────────────────────────────── */

const BRANCHES = [
  {
    id: "ind", name: "Indiranagar", short: "IND",
    students: { total: 1240, present: 1152 },
    teachers: { total: 68, present: 64 },
    staff: { total: 42, present: 39 },
    revenueYTD: 842,
    passRate: { prev: 91.2, curr: 94.6 },
    passHistory: [88.9, 90.4, 91.2, 94.6],
    attendanceTrend: [94, 93, 95, 92, 94, 93],
    admissions: { target: 260, enquiries: 612, applications: 348, admitted: 214 },
    feeMix: { Tuition: 588, Transport: 118, Hostel: 76, Activities: 60 },
    fees: [
      { m: "Apr", target: 210, collected: 198 }, { m: "May", target: 160, collected: 149 },
      { m: "Jun", target: 165, collected: 151 }, { m: "Jul", target: 170, collected: 158 },
      { m: "Aug", target: 175, collected: 121 },
    ],
  },
  {
    id: "wtf", name: "Whitefield", short: "WTF",
    students: { total: 1685, present: 1521 },
    teachers: { total: 92, present: 85 },
    staff: { total: 55, present: 51 },
    revenueYTD: 1186,
    passRate: { prev: 88.4, curr: 90.1 },
    passHistory: [86.1, 87.2, 88.4, 90.1],
    attendanceTrend: [91, 92, 90, 91, 89, 90],
    admissions: { target: 320, enquiries: 780, applications: 431, admitted: 287 },
    feeMix: { Tuition: 812, Transport: 176, Hostel: 118, Activities: 80 },
    fees: [
      { m: "Apr", target: 300, collected: 291 }, { m: "May", target: 225, collected: 214 },
      { m: "Jun", target: 230, collected: 221 }, { m: "Jul", target: 235, collected: 226 },
      { m: "Aug", target: 240, collected: 178 },
    ],
  },
  {
    id: "jay", name: "Jayanagar", short: "JAY",
    students: { total: 980, present: 941 },
    teachers: { total: 54, present: 52 },
    staff: { total: 34, present: 33 },
    revenueYTD: 612,
    passRate: { prev: 93.5, curr: 92.8 },
    passHistory: [92.8, 93.9, 93.5, 92.8],
    attendanceTrend: [96, 97, 96, 95, 96, 96],
    admissions: { target: 200, enquiries: 445, applications: 276, admitted: 188 },
    feeMix: { Tuition: 436, Transport: 82, Hostel: 52, Activities: 42 },
    fees: [
      { m: "Apr", target: 150, collected: 147 }, { m: "May", target: 115, collected: 112 },
      { m: "Jun", target: 118, collected: 116 }, { m: "Jul", target: 120, collected: 117 },
      { m: "Aug", target: 122, collected: 104 },
    ],
  },
  {
    id: "heb", name: "Hebbal", short: "HEB",
    students: { total: 1120, present: 1004 },
    teachers: { total: 61, present: 55 },
    staff: { total: 38, present: 34 },
    revenueYTD: 705,
    passRate: { prev: 85.1, curr: 89.3 },
    passHistory: [83.6, 84.2, 85.1, 89.3],
    attendanceTrend: [90, 89, 91, 88, 90, 90],
    admissions: { target: 240, enquiries: 502, applications: 298, admitted: 171 },
    feeMix: { Tuition: 486, Transport: 104, Hostel: 64, Activities: 51 },
    fees: [
      { m: "Apr", target: 180, collected: 152 }, { m: "May", target: 135, collected: 108 },
      { m: "Jun", target: 138, collected: 111 }, { m: "Jul", target: 142, collected: 116 },
      { m: "Aug", target: 145, collected: 89 },
    ],
  },
  {
    id: "ecy", name: "Electronic City", short: "ECY",
    students: { total: 1435, present: 1350 },
    teachers: { total: 78, present: 74 },
    staff: { total: 47, present: 45 },
    revenueYTD: 934,
    passRate: { prev: 89.9, curr: 93.2 },
    passHistory: [87.5, 88.8, 89.9, 93.2],
    attendanceTrend: [93, 94, 94, 95, 93, 94],
    admissions: { target: 300, enquiries: 688, applications: 402, admitted: 259 },
    feeMix: { Tuition: 648, Transport: 138, Hostel: 86, Activities: 62 },
    fees: [
      { m: "Apr", target: 235, collected: 228 }, { m: "May", target: 178, collected: 169 },
      { m: "Jun", target: 182, collected: 174 }, { m: "Jul", target: 186, collected: 176 },
      { m: "Aug", target: 190, collected: 141 },
    ],
  },
];

/* ── Helpers ──────────────────────────────────────────────────── */

const sum = (arr, f) => arr.reduce((a, b) => a + f(b), 0);
const pct = (a, b) => (b === 0 ? 0 : Math.round((a / b) * 1000) / 10);
const num = (n) => Math.round(n).toLocaleString("en-IN");
const inr = (lakh) => (lakh >= 100 ? `₹${(lakh / 100).toFixed(2)} Cr` : `₹${Math.round(lakh)} L`);

function aggregate(list) {
  const months = ["Apr", "May", "Jun", "Jul", "Aug"];
  const heads = ["Tuition", "Transport", "Hostel", "Activities"];
  const totStu = sum(list, b => b.students.total);
  return {
    id: "all", name: "All Schools",
    students: { total: totStu, present: sum(list, b => b.students.present) },
    teachers: { total: sum(list, b => b.teachers.total), present: sum(list, b => b.teachers.present) },
    staff: { total: sum(list, b => b.staff.total), present: sum(list, b => b.staff.present) },
    revenueYTD: sum(list, b => b.revenueYTD),
    passRate: {
      prev: sum(list, b => b.passRate.prev * b.students.total) / totStu,
      curr: sum(list, b => b.passRate.curr * b.students.total) / totStu,
    },
    passHistory: [0, 1, 2, 3].map(i => sum(list, b => b.passHistory[i] * b.students.total) / totStu),
    attendanceTrend: [0, 1, 2, 3, 4, 5].map(i => sum(list, b => b.attendanceTrend[i] * b.students.total) / totStu),
    admissions: {
      target: sum(list, b => b.admissions.target),
      enquiries: sum(list, b => b.admissions.enquiries),
      applications: sum(list, b => b.admissions.applications),
      admitted: sum(list, b => b.admissions.admitted),
    },
    feeMix: Object.fromEntries(heads.map(h => [h, sum(list, b => b.feeMix[h])])),
    fees: months.map((m, i) => ({
      m, target: sum(list, b => b.fees[i].target), collected: sum(list, b => b.fees[i].collected),
    })),
  };
}

/* Animated count-up */
function useCountUp(target, duration = 750) {
  const [val, setVal] = useState(0);
  const fromRef = useRef(0);
  useEffect(() => {
    const reduce = window.matchMedia?.("(prefers-reduced-motion: reduce)").matches;
    if (reduce) { setVal(target); fromRef.current = target; return; }
    const from = fromRef.current;
    const start = performance.now();
    let raf;
    const step = (t) => {
      const p = Math.min(1, (t - start) / duration);
      const e = 1 - Math.pow(1 - p, 3);
      setVal(from + (target - from) * e);
      if (p < 1) raf = requestAnimationFrame(step);
      else fromRef.current = target;
    };
    raf = requestAnimationFrame(step);
    return () => cancelAnimationFrame(raf);
  }, [target, duration]);
  return val;
}

/* ── Atoms ────────────────────────────────────────────────────── */

function Eyebrow({ children, color }) {
  return (
    <div style={{
      fontFamily: "'Space Grotesk', sans-serif", fontSize: 11, fontWeight: 600,
      letterSpacing: "0.16em", textTransform: "uppercase", color,
    }}>{children}</div>
  );
}

function Delta({ value, suffix = "" }) {
  const up = value >= 0;
  return (
    <span style={{
      fontFamily: "'Space Grotesk', sans-serif", fontSize: 12, fontWeight: 700,
      color: up ? ACC.green : ACC.red,
      background: up ? "rgba(34,181,115,.14)" : "rgba(239,90,76,.14)",
      padding: "3px 9px", borderRadius: 999, whiteSpace: "nowrap",
    }}>
      {up ? "▲" : "▼"} {Math.abs(value).toFixed(1)}{suffix}
    </span>
  );
}

function Spark({ data, color, w = 92, h = 30 }) {
  if (!data || data.length < 2) return null;
  const min = Math.min(...data), max = Math.max(...data);
  const rng = max - min || 1;
  const pts = data.map((v, i) => [
    (i / (data.length - 1)) * (w - 4) + 2,
    h - 3 - ((v - min) / rng) * (h - 8),
  ]);
  const d = pts.map((p, i) => `${i ? "L" : "M"}${p[0].toFixed(1)},${p[1].toFixed(1)}`).join(" ");
  const gid = `sg-${color.replace("#", "")}-${w}`;
  return (
    <svg width={w} height={h} viewBox={`0 0 ${w} ${h}`} aria-hidden="true">
      <defs>
        <linearGradient id={gid} x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor={color} stopOpacity=".28" />
          <stop offset="100%" stopColor={color} stopOpacity="0" />
        </linearGradient>
      </defs>
      <path d={`${d} L${w - 2},${h} L2,${h} Z`} fill={`url(#${gid})`} />
      <path d={d} fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" />
      <circle cx={pts[pts.length - 1][0]} cy={pts[pts.length - 1][1]} r="3" fill={color} />
    </svg>
  );
}

function Card({ T, children, style, className = "" }) {
  return (
    <div className={`vd-card ${className}`} style={{
      background: T.card, border: `1px solid ${T.cardBorder}`,
      borderRadius: 18, padding: "20px 22px", ...style,
    }}>{children}</div>
  );
}

function SectionTitle({ T, eyebrow, title, right }) {
  return (
    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", gap: 10, flexWrap: "wrap" }}>
      <div>
        <Eyebrow color={T.faint}>{eyebrow}</Eyebrow>
        <h2 style={{
          fontFamily: "'Space Grotesk', sans-serif", fontSize: 19, fontWeight: 700,
          color: T.ink, margin: "5px 0 0", letterSpacing: "-0.01em",
        }}>{title}</h2>
      </div>
      {right}
    </div>
  );
}

/* Gradient attendance ring */
function Ring({ T, id, label, present, total, from, to }) {
  const p = pct(present, total);
  const r = 42, circ = 2 * Math.PI * r;
  return (
    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 9, minWidth: 118 }}>
      <div style={{ position: "relative", width: 108, height: 108 }}>
        <svg width="108" height="108" viewBox="0 0 108 108">
          <defs>
            <linearGradient id={`ring-${id}`} x1="0" y1="0" x2="1" y2="1">
              <stop offset="0%" stopColor={from} />
              <stop offset="100%" stopColor={to} />
            </linearGradient>
          </defs>
          <circle cx="54" cy="54" r={r} fill="none" stroke={T.trackBg} strokeWidth="10" />
          <circle className="vd-ring" cx="54" cy="54" r={r} fill="none"
            stroke={`url(#ring-${id})`} strokeWidth="10" strokeLinecap="round"
            strokeDasharray={circ} strokeDashoffset={circ * (1 - p / 100)}
            transform="rotate(-90 54 54)" />
        </svg>
        <div style={{ position: "absolute", inset: 0, display: "grid", placeItems: "center" }}>
          <div style={{ textAlign: "center" }}>
            <div style={{ fontFamily: "'Space Grotesk', sans-serif", fontSize: 21, fontWeight: 700, color: T.ink, fontVariantNumeric: "tabular-nums" }}>{p}%</div>
            <div style={{ fontSize: 9.5, color: T.faint, fontWeight: 600, letterSpacing: ".08em" }}>PRESENT</div>
          </div>
        </div>
      </div>
      <div style={{ textAlign: "center" }}>
        <div style={{ fontWeight: 600, fontSize: 13, color: T.text }}>{label}</div>
        <div style={{ fontSize: 11.5, color: T.muted, fontVariantNumeric: "tabular-nums" }}>
          {num(present)}/{num(total)} · <span style={{ color: ACC.red, fontWeight: 600 }}>{num(total - present)} out</span>
        </div>
      </div>
    </div>
  );
}

/* Pass-rate slopegraph */
function SlopeChart({ T, branches, selectedId }) {
  const W = 460, H = 288, padX = 118, padT = 32, padB = 22;
  const all = branches.flatMap(b => [b.passRate.prev, b.passRate.curr]);
  const min = Math.floor(Math.min(...all)) - 2;
  const max = Math.ceil(Math.max(...all)) + 2;
  const y = v => padT + (H - padT - padB) * (1 - (v - min) / (max - min));
  const x0 = padX, x1 = W - padX;
  return (
    <svg viewBox={`0 0 ${W} ${H}`} style={{ width: "100%", height: "auto" }}>
      {[x0, x1].map((x, i) => (
        <line key={i} x1={x} y1={padT - 10} x2={x} y2={H - padB + 6} stroke={T.hair} strokeWidth="1" />
      ))}
      <text x={x0} y={15} textAnchor="middle" style={{ fontFamily: "Space Grotesk", fontSize: 11, fontWeight: 600, fill: T.faint, letterSpacing: ".1em" }}>AY 2024-25</text>
      <text x={x1} y={15} textAnchor="middle" style={{ fontFamily: "Space Grotesk", fontSize: 11, fontWeight: 600, fill: T.faint, letterSpacing: ".1em" }}>AY 2025-26</text>
      {branches.map((b, i) => {
        const dim = selectedId !== "all" && selectedId !== b.id;
        const col = dim ? T.hair : BRANCH_COLORS[i % BRANCH_COLORS.length];
        const down = b.passRate.curr < b.passRate.prev;
        return (
          <g key={b.id} opacity={dim ? 0.6 : 1}>
            <line x1={x0} y1={y(b.passRate.prev)} x2={x1} y2={y(b.passRate.curr)}
              stroke={col} strokeWidth={dim ? 1.5 : 2.6}
              strokeDasharray={down && !dim ? "5 4" : "none"} strokeLinecap="round" />
            <circle cx={x0} cy={y(b.passRate.prev)} r={dim ? 3 : 4.5} fill={col} />
            <circle cx={x1} cy={y(b.passRate.curr)} r={dim ? 3 : 4.5} fill={col} />
            <text x={x0 - 10} y={y(b.passRate.prev) + 4} textAnchor="end"
              style={{ fontFamily: "Inter", fontSize: 11.5, fill: dim ? T.faint : T.text, fontVariantNumeric: "tabular-nums" }}>
              {b.short} · {b.passRate.prev.toFixed(1)}
            </text>
            <text x={x1 + 10} y={y(b.passRate.curr) + 4}
              style={{ fontFamily: "Inter", fontSize: 11.5, fontWeight: dim ? 400 : 700, fill: dim ? T.faint : col, fontVariantNumeric: "tabular-nums" }}>
              {b.passRate.curr.toFixed(1)} {down ? "▼" : "▲"}
            </text>
          </g>
        );
      })}
    </svg>
  );
}

/* Admissions funnel */
function Funnel({ T, adm }) {
  const stages = [
    { label: "Enquiries", v: adm.enquiries, color: ACC.cobalt },
    { label: "Applications", v: adm.applications, color: ACC.violet },
    { label: "Admitted", v: adm.admitted, color: ACC.green },
  ];
  const maxV = stages[0].v;
  const conv = pct(adm.admitted, adm.enquiries);
  const filled = pct(adm.admitted, adm.target);
  return (
    <div>
      <div style={{ display: "flex", flexDirection: "column", gap: 13 }}>
        {stages.map((s, i) => (
          <div key={s.label}>
            <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 5 }}>
              <span style={{ fontSize: 13, fontWeight: 600, color: T.text }}>{s.label}</span>
              <span style={{ fontSize: 13, fontWeight: 700, color: T.ink, fontVariantNumeric: "tabular-nums" }}>
                {num(s.v)}{i > 0 && <span style={{ color: T.faint, fontWeight: 500 }}> ({pct(s.v, stages[i - 1].v)}%)</span>}
              </span>
            </div>
            <div style={{ height: 11, background: T.trackBg, borderRadius: 999, overflow: "hidden" }}>
              <div className="vd-bar" style={{
                width: `${(s.v / maxV) * 100}%`, height: "100%", borderRadius: 999,
                background: `linear-gradient(90deg, ${s.color}CC, ${s.color})`,
              }} />
            </div>
          </div>
        ))}
      </div>
      <div style={{ display: "flex", gap: 10, marginTop: 16, paddingTop: 15, borderTop: `1px dashed ${T.hair}` }}>
        <div style={{ flex: 1, background: T.trackBg, borderRadius: 12, padding: "10px 12px" }}>
          <div style={{ fontSize: 11, color: T.muted, fontWeight: 600 }}>Enquiry → admit</div>
          <div style={{ fontFamily: "Space Grotesk", fontSize: 20, fontWeight: 700, color: T.ink, fontVariantNumeric: "tabular-nums" }}>{conv}%</div>
        </div>
        <div style={{
          flex: 1.4, borderRadius: 12, padding: "10px 12px",
          background: filled >= 75 ? "rgba(34,181,115,.13)" : "rgba(233,162,59,.14)",
        }}>
          <div style={{ fontSize: 11, color: T.muted, fontWeight: 600 }}>Seats filled vs target {num(adm.target)}</div>
          <div style={{ fontFamily: "Space Grotesk", fontSize: 20, fontWeight: 700, fontVariantNumeric: "tabular-nums", color: filled >= 75 ? ACC.green : ACC.amber }}>{filled}%</div>
        </div>
      </div>
    </div>
  );
}

/* Revenue mix donut */
function MixDonut({ T, mix }) {
  const data = Object.entries(mix).map(([name, value]) => ({ name, value }));
  const total = sum(data, d => d.value);
  const cols = [ACC.cobalt, ACC.teal, ACC.violet, ACC.amber];
  return (
    <div style={{ display: "flex", alignItems: "center", gap: 6, flexWrap: "wrap" }}>
      <div style={{ width: 168, height: 168, position: "relative", flexShrink: 0 }}>
        <ResponsiveContainer width="100%" height="100%">
          <PieChart>
            <Pie data={data} dataKey="value" innerRadius={54} outerRadius={78}
              paddingAngle={3} strokeWidth={0} startAngle={90} endAngle={-270}>
              {data.map((_, i) => <Cell key={i} fill={cols[i % cols.length]} />)}
            </Pie>
            <Tooltip
              formatter={(v, n) => [`${inr(v)} · ${pct(v, total)}%`, n]}
              contentStyle={{
                borderRadius: 10, border: `1px solid ${T.cardBorder}`, background: T.tooltipBg,
                fontFamily: "Inter", fontSize: 12.5, color: T.ink,
              }}
              itemStyle={{ color: T.ink }}
            />
          </PieChart>
        </ResponsiveContainer>
        <div style={{ position: "absolute", inset: 0, display: "grid", placeItems: "center", pointerEvents: "none" }}>
          <div style={{ textAlign: "center" }}>
            <div style={{ fontFamily: "Space Grotesk", fontSize: 17, fontWeight: 700, color: T.ink }}>{inr(total)}</div>
            <div style={{ fontSize: 10, color: T.faint, fontWeight: 600, letterSpacing: ".06em" }}>YTD</div>
          </div>
        </div>
      </div>
      <div style={{ display: "flex", flexDirection: "column", gap: 9, flex: 1, minWidth: 150 }}>
        {data.map((d, i) => (
          <div key={d.name} style={{ display: "flex", alignItems: "center", gap: 9, fontSize: 12.5 }}>
            <span style={{ width: 9, height: 9, borderRadius: 3, background: cols[i % cols.length], flexShrink: 0 }} />
            <span style={{ color: T.muted, flex: 1 }}>{d.name}</span>
            <strong style={{ color: T.ink, fontVariantNumeric: "tabular-nums" }}>{inr(d.value)}</strong>
            <span style={{ color: T.faint, width: 42, textAlign: "right", fontVariantNumeric: "tabular-nums" }}>{pct(d.value, total)}%</span>
          </div>
        ))}
      </div>
    </div>
  );
}

/* KPI card */
function KpiCard({ T, icon: Icon, gradFrom, gradTo, label, value, format, sub, delta, spark, sparkColor }) {
  const animated = useCountUp(value);
  return (
    <Card T={T} style={{ padding: "17px 18px", position: "relative", overflow: "hidden" }}>
      <div style={{
        position: "absolute", top: -46, right: -46, width: 130, height: 130, borderRadius: "50%",
        background: `radial-gradient(circle, ${gradFrom}22 0%, transparent 70%)`, pointerEvents: "none",
      }} />
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
        <div style={{
          width: 40, height: 40, borderRadius: 12, display: "grid", placeItems: "center",
          background: `linear-gradient(135deg, ${gradFrom}, ${gradTo})`,
          boxShadow: `0 6px 16px ${gradFrom}55`,
        }}>
          <Icon size={20} color="#fff" strokeWidth={2.2} />
        </div>
        {typeof delta === "number" && <Delta value={delta} suffix=" pts" />}
      </div>
      <div style={{ marginTop: 13, display: "flex", alignItems: "flex-end", justifyContent: "space-between", gap: 8 }}>
        <div style={{ minWidth: 0 }}>
          <div style={{
            fontFamily: "'Space Grotesk', sans-serif", fontSize: 28, fontWeight: 700,
            color: T.ink, letterSpacing: "-0.02em", fontVariantNumeric: "tabular-nums", lineHeight: 1.05,
          }}>{format(animated)}</div>
          <div style={{ fontSize: 12, fontWeight: 600, color: T.muted, marginTop: 5 }}>{label}</div>
        </div>
        {spark && <Spark data={spark} color={sparkColor || gradFrom} />}
      </div>
      <div style={{ fontSize: 11.5, color: T.faint, marginTop: 7, lineHeight: 1.45 }}>{sub}</div>
    </Card>
  );
}

/* ── Main ─────────────────────────────────────────────────────── */

export default function ExecutiveDashboard() {
  const [selected, setSelected] = useState("all");
  const [dark, setDark] = useState(false);
  const T = dark ? THEMES.dark : THEMES.light;

  const view = useMemo(
    () => (selected === "all" ? aggregate(BRANCHES) : BRANCHES.find(b => b.id === selected)),
    [selected]
  );

  const feeTargetYTD = sum(view.fees, f => f.target);
  const feeCollectedYTD = sum(view.fees, f => f.collected);
  const collectionRate = pct(feeCollectedYTD, feeTargetYTD);
  const outstanding = feeTargetYTD - feeCollectedYTD;
  const passDelta = view.passRate.curr - view.passRate.prev;
  const ratio = Math.round(view.students.total / view.teachers.total);
  const filledPct = pct(view.admissions.admitted, view.admissions.target);

  const alerts = useMemo(() => {
    const list = [];
    const src = selected === "all" ? BRANCHES : [view];
    src.forEach(b => {
      const cr = pct(sum(b.fees, f => f.collected), sum(b.fees, f => f.target));
      if (cr < 80) list.push({ tone: "red", icon: Wallet, branch: b.name, text: `Fee collection at ${cr}% — ${inr(sum(b.fees, f => f.target) - sum(b.fees, f => f.collected))} outstanding` });
      if (b.passRate.curr < b.passRate.prev) list.push({ tone: "amber", icon: TrendingDown, branch: b.name, text: `Pass rate slipped ${(b.passRate.prev - b.passRate.curr).toFixed(1)} pts year-on-year` });
      const ta = pct(b.teachers.present, b.teachers.total);
      if (ta < 92) list.push({ tone: "amber", icon: Users, branch: b.name, text: `Teacher attendance ${ta}% today (${b.teachers.total - b.teachers.present} absent)` });
      const fl = pct(b.admissions.admitted, b.admissions.target);
      if (fl < 75) list.push({ tone: "red", icon: Target, branch: b.name, text: `Admissions at ${fl}% of seat target — intake window closing` });
      const sa = pct(b.students.present, b.students.total);
      if (sa < 91) list.push({ tone: "amber", icon: AlertTriangle, branch: b.name, text: `Student attendance dipped to ${sa}% today` });
    });
    return list;
  }, [selected, view]);

  const feeRateTrend = view.fees.map(f => pct(f.collected, f.target));

  return (
    <div style={{
      minHeight: "100vh", background: T.bg, color: T.text,
      fontFamily: "'Inter', system-ui, sans-serif", position: "relative",
      transition: "background .35s ease, color .35s ease",
    }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Space+Grotesk:wght@500;600;700&family=Inter:wght@400;500;600;700&display=swap');
        * { box-sizing: border-box; margin: 0; }
        ::selection { background: ${ACC.cobalt}44; }
        .vd-card { transition: box-shadow .2s ease, transform .2s ease, background .35s ease, border-color .35s ease; }
        .vd-card:hover { box-shadow: ${T.shadow}; transform: translateY(-2px); }
        .vd-fade { animation: vdFade .55s ease both; }
        .vd-ring { transition: stroke-dashoffset .9s cubic-bezier(.4,0,.2,1); }
        .vd-bar { transition: width .7s cubic-bezier(.4,0,.2,1); }
        .vd-select { appearance: none; -webkit-appearance: none; cursor: pointer; transition: border-color .2s; }
        .vd-select:hover { border-color: ${ACC.cobalt}; }
        .vd-select:focus { outline: 2px solid ${ACC.cobalt}; outline-offset: 2px; }
        .vd-toggle { cursor: pointer; transition: transform .2s ease, background .3s ease; }
        .vd-toggle:hover { transform: scale(1.06); }
        .vd-toggle:focus-visible { outline: 2px solid ${ACC.cobalt}; outline-offset: 2px; }
        .vd-row { transition: background .15s ease; cursor: pointer; }
        .vd-row:hover { background: ${T.rowHover}; }
        .vd-hero { background: linear-gradient(120deg, #12234A 0%, #1D3A7A 34%, #2B5AD0 62%, #0E8F86 100%); background-size: 220% 220%; animation: vdMesh 14s ease-in-out infinite; }
        .vd-chip { backdrop-filter: blur(8px); }
        @keyframes vdMesh { 0%,100% { background-position: 0% 40%; } 50% { background-position: 100% 60%; } }
        @keyframes vdFade { from { opacity: 0; transform: translateY(10px); } to { opacity: 1; transform: none; } }
        @keyframes vdPulse { 0%,100% { opacity: 1; } 50% { opacity: .45; } }
        .vd-live { animation: vdPulse 2s ease-in-out infinite; }
        @media (prefers-reduced-motion: reduce) {
          .vd-fade, .vd-ring, .vd-bar, .vd-card, .vd-hero, .vd-live { animation: none !important; transition: none !important; }
        }
        .vd-grid-kpi { display: grid; grid-template-columns: repeat(4, 1fr); gap: 14px; }
        .vd-grid-a { display: grid; grid-template-columns: 0.95fr 1.45fr; gap: 14px; }
        .vd-grid-b { display: grid; grid-template-columns: 1.3fr 1fr; gap: 14px; }
        .vd-grid-c { display: grid; grid-template-columns: 1fr 1.55fr; gap: 14px; }
        @media (max-width: 1080px) {
          .vd-grid-a, .vd-grid-b, .vd-grid-c { grid-template-columns: 1fr; }
          .vd-grid-kpi { grid-template-columns: 1fr 1fr; }
        }
        @media (max-width: 600px) {
          .vd-grid-kpi { grid-template-columns: 1fr; }
          .vd-pad { padding-left: 16px !important; padding-right: 16px !important; }
          .vd-hero-title { font-size: 26px !important; }
        }
      `}</style>

      {/* ambient glows */}
      <div aria-hidden="true" style={{
        position: "fixed", inset: 0, pointerEvents: "none", zIndex: 0,
        background: `radial-gradient(600px 400px at 12% -5%, ${T.bgGlow1}, transparent 60%),
                     radial-gradient(700px 480px at 95% 8%, ${T.bgGlow2}, transparent 65%)`,
      }} />

      {/* ── Sticky glass header ── */}
      <header style={{
        position: "sticky", top: 0, zIndex: 40,
        background: T.headerBg, backdropFilter: "blur(14px)", WebkitBackdropFilter: "blur(14px)",
        borderBottom: `1px solid ${T.hair}`,
      }}>
        <div className="vd-pad" style={{
          width: "100%", maxWidth: "none", margin: "0", padding: "12px 28px",
          display: "flex", alignItems: "center", gap: 14, flexWrap: "wrap",
        }}>
          <div style={{ display: "flex", alignItems: "center", gap: 11, marginRight: "auto" }}>
            <div style={{
              width: 38, height: 38, borderRadius: 11, display: "grid", placeItems: "center",
              background: `linear-gradient(135deg, ${ACC.cobalt}, ${ACC.violet})`,
              boxShadow: `0 6px 16px ${ACC.cobalt}55`,
            }}>
              <GraduationCap size={20} color="#fff" />
            </div>
            <div>
              <div style={{ fontFamily: "Space Grotesk", fontWeight: 700, fontSize: 15.5, color: T.ink, letterSpacing: "-0.01em" }}>
               GreenWood High
              </div>
              {/* <div style={{ fontSize: 11, color: T.faint, fontWeight: 500 }}>Executive Command Center</div> */}
            </div>
          </div>

          <div style={{ position: "relative" }}>
            <select
              className="vd-select"
              aria-label="Select campus"
              value={selected}
              onChange={e => setSelected(e.target.value)}
              style={{
                background: T.card, color: T.ink, border: `1.5px solid ${T.cardBorder}`,
                borderRadius: 11, padding: "10px 40px 10px 14px",
                fontFamily: "Inter", fontSize: 13.5, fontWeight: 600, minWidth: 210,
              }}
            >
              <option value="all">🏛 All schools (group)</option>
              {BRANCHES.map(b => <option key={b.id} value={b.id}>{b.name} Campus</option>)}
            </select>
            <ChevronDown size={15} style={{ position: "absolute", right: 13, top: "50%", transform: "translateY(-50%)", pointerEvents: "none", color: T.faint }} />
          </div>

          <button
            className="vd-toggle"
            aria-label={dark ? "Switch to light mode" : "Switch to dark mode"}
            onClick={() => setDark(d => !d)}
            style={{
              width: 40, height: 40, borderRadius: 11, border: `1.5px solid ${T.cardBorder}`,
              background: T.card, display: "grid", placeItems: "center", color: T.ink,
            }}
          >
            {dark ? <Sun size={18} /> : <Moon size={18} />}
          </button>
        </div>
      </header>

      <main className="vd-pad" style={{ width: "100%", maxWidth: "none", margin: "0", padding: "22px 28px 52px", position: "relative", zIndex: 1 }}>

    
        <section className="vd-hero vd-fade" style={{
          borderRadius: 22, padding: "26px 28px", color: "#fff",
          position: "relative", overflow: "hidden",
        }}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-end", flexWrap: "wrap", gap: 16 }}>
            <div>
              <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 8 }}>
                <span className="vd-chip" style={{
                  display: "inline-flex", alignItems: "center", gap: 6,
                  background: "rgba(255,255,255,.16)", borderRadius: 999, padding: "5px 12px",
                  fontSize: 11.5, fontWeight: 600, letterSpacing: ".04em",
                }}>
                  <span className="vd-live" style={{ width: 7, height: 7, borderRadius: 99, background: "#5EF2C4", display: "inline-block" }} />
                  LIVE · refreshed 09:40 IST
                </span>
                <span className="vd-chip" style={{
                  display: "inline-flex", alignItems: "center", gap: 6,
                  background: "rgba(255,255,255,.16)", borderRadius: 999, padding: "5px 12px",
                  fontSize: 11.5, fontWeight: 600,
                }}>
                  <Clock size={12} /> AY 2026-27
                </span>
              </div>
              <h1 className="vd-hero-title" style={{
                fontFamily: "'Space Grotesk', sans-serif", fontSize: 32, fontWeight: 700,
                letterSpacing: "-0.02em", lineHeight: 1.12,
              }}>
                {selected === "all" ? "Group performance, at a glance" : `${view.name} Campus`}
              </h1>
              <p style={{ marginTop: 7, fontSize: 13.5, color: "rgba(255,255,255,.82)" }}>
                Friday, 28 August 2026 · {selected === "all" ? "5 campuses · Bengaluru" : "Single-campus focus · click any leaderboard row to switch"}
              </p>
            </div>
            <div style={{ display: "flex", gap: 22, flexWrap: "wrap" }}>
              {[
                { l: "Campuses", v: selected === "all" ? "5" : "1", i: Building2 },
                { l: "People on site", v: num(view.students.present + view.teachers.present + view.staff.present), i: Users },
                { l: "Seats filled", v: `${filledPct}%`, i: Sparkles },
              ].map(s => (
                <div key={s.l} style={{ textAlign: "right" }}>
                  <div style={{ fontFamily: "Space Grotesk", fontSize: 24, fontWeight: 700, fontVariantNumeric: "tabular-nums" }}>{s.v}</div>
                  <div style={{ fontSize: 11.5, color: "rgba(255,255,255,.75)", fontWeight: 500 }}>{s.l}</div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* ── KPI cards ── */}
        <section className="vd-grid-kpi vd-fade" style={{ marginTop: 14, animationDelay: ".05s" }}>
          <KpiCard T={T} icon={Users} gradFrom={ACC.cobalt} gradTo={ACC.violet}
            label="Students on roll" value={view.students.total} format={v => num(v)}
            sub={`${num(view.students.present)} present · ${num(view.students.total - view.students.present)} absent today · ratio ${ratio}:1`}
            spark={view.attendanceTrend} sparkColor={ACC.cobalt} />
          <KpiCard T={T} icon={Wallet} gradFrom={ACC.teal} gradTo={ACC.green}
            label="Revenue · YTD" value={view.revenueYTD} format={v => inr(v)}
            sub="Apr – Aug 2026 · all fee heads combined"
            spark={view.fees.map(f => f.collected)} sparkColor={ACC.teal} />
          <KpiCard T={T} icon={Target} gradFrom={ACC.amber} gradTo={"#D97706"}
            label="Fee collection rate" value={collectionRate} format={v => `${v.toFixed(1)}%`}
            sub={`${inr(outstanding)} outstanding of ${inr(feeTargetYTD)} billed`}
            spark={feeRateTrend} sparkColor={ACC.amber} />
          <KpiCard T={T} icon={GraduationCap} gradFrom={ACC.violet} gradTo={ACC.cobalt}
            label="Pass rate · AY 25-26" value={view.passRate.curr} format={v => `${v.toFixed(1)}%`}
            delta={passDelta} sub="4-year trajectory shown · vs previous academic year"
            spark={view.passHistory} sparkColor={ACC.violet} />
        </section>

        {/* ── Attendance + fee collection ── */}
        <section className="vd-grid-a vd-fade" style={{ marginTop: 14, animationDelay: ".1s" }}>
          <Card T={T}>
            <SectionTitle T={T} eyebrow="Attendance · today" title="Who's on campus" />
            <div style={{ display: "flex", justifyContent: "space-between", gap: 6, marginTop: 18, flexWrap: "wrap" }}>
              <Ring T={T} id="stu" label="Students" present={view.students.present} total={view.students.total} from={ACC.cobalt} to={ACC.violet} />
              <Ring T={T} id="tch" label="Teachers" present={view.teachers.present} total={view.teachers.total} from={ACC.teal} to={ACC.green} />
              <Ring T={T} id="stf" label="Support staff" present={view.staff.present} total={view.staff.total} from={ACC.amber} to={"#D97706"} />
            </div>
            <div style={{
              marginTop: 18, padding: "11px 14px", borderRadius: 12, background: T.trackBg,
              display: "flex", justifyContent: "space-between", fontSize: 12.5, color: T.muted,
            }}>
              <span>6-day student attendance trend</span>
              <Spark data={view.attendanceTrend} color={ACC.cobalt} w={110} h={24} />
            </div>
          </Card>

          <Card T={T}>
            <SectionTitle T={T} eyebrow="Tuition fees · monthly" title="Collection vs billed target"
              right={<span style={{ fontSize: 12, color: T.faint }}>₹ lakh · Aug in progress</span>} />
            <div style={{ height: 252, marginTop: 12 }}>
              <ResponsiveContainer width="100%" height="100%">
                <ComposedChart data={view.fees} barGap={4} margin={{ top: 8, right: 8, left: -12, bottom: 0 }}>
                  <defs>
                    <linearGradient id="colGrad" x1="0" y1="0" x2="0" y2="1">
                      <stop offset="0%" stopColor={ACC.teal} />
                      <stop offset="100%" stopColor={ACC.green} stopOpacity=".55" />
                    </linearGradient>
                  </defs>
                  <CartesianGrid stroke={T.hair} strokeDasharray="3 4" vertical={false} />
                  <XAxis dataKey="m" tick={{ fontFamily: "Inter", fontSize: 12, fill: T.muted }} axisLine={{ stroke: T.hair }} tickLine={false} />
                  <YAxis tick={{ fontFamily: "Inter", fontSize: 12, fill: T.muted }} axisLine={false} tickLine={false} />
                  <Tooltip
                    cursor={{ fill: T.rowHover }}
                    formatter={(v, n) => [`₹${num(v)} L`, n === "collected" ? "Collected" : "Billed target"]}
                    contentStyle={{ borderRadius: 12, border: `1px solid ${T.cardBorder}`, background: T.tooltipBg, fontFamily: "Inter", fontSize: 13, color: T.ink }}
                    itemStyle={{ color: T.ink }} labelStyle={{ color: T.muted, fontWeight: 600 }}
                  />
                  <Bar dataKey="collected" fill="url(#colGrad)" radius={[6, 6, 0, 0]} maxBarSize={42} />
                  <Line dataKey="target" stroke={dark ? "#8FB0FF" : T.ink} strokeWidth={2.2} dot={{ r: 3.5, fill: dark ? "#8FB0FF" : T.ink }} type="monotone" />
                </ComposedChart>
              </ResponsiveContainer>
            </div>
          </Card>
        </section>

        {/* ── Slope + funnel ── */}
        <section className="vd-grid-b vd-fade" style={{ marginTop: 14, animationDelay: ".15s" }}>
          <Card T={T}>
            <SectionTitle T={T} eyebrow="Academic outcomes" title="Pass rate — this year vs last" />
            <p style={{ fontSize: 12.5, color: T.muted, margin: "6px 0 4px" }}>
              One line per campus · dashed means the result slipped year-on-year · selecting a campus dims the rest.
            </p>
            <SlopeChart T={T} branches={BRANCHES} selectedId={selected} />
          </Card>
          <Card T={T}>
            <SectionTitle T={T} eyebrow="Admissions · AY 2026-27 intake" title="Enquiry to enrolment" />
            <div style={{ marginTop: 16 }}>
              <Funnel T={T} adm={view.admissions} />
            </div>
          </Card>
        </section>

        {/* ── Revenue mix + leaderboard ── */}
        <section className="vd-grid-c vd-fade" style={{ marginTop: 14, animationDelay: ".2s" }}>
          <Card T={T}>
            <SectionTitle T={T} eyebrow="Finance" title="Revenue mix by fee head" />
            <div style={{ marginTop: 14 }}>
              <MixDonut T={T} mix={view.feeMix} />
            </div>
          </Card>

          <Card T={T} style={{ padding: 0, overflow: "hidden" }}>
            <div style={{ padding: "20px 22px 12px" }}>
              <SectionTitle T={T} eyebrow="Campus leaderboard" title="Branch-by-branch report"
                right={<span style={{ fontSize: 12, color: T.faint }}>ranked by pass-rate gain</span>} />
            </div>
            <div style={{ overflowX: "auto" }}>
              <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 13, minWidth: 620 }}>
                <thead>
                  <tr style={{ borderTop: `1px solid ${T.hair}`, borderBottom: `1px solid ${T.hair}`, background: T.theadBg }}>
                    {["#", "Campus", "Students", "Attend.", "Revenue", "Fees", "Pass Δ", "Seats"].map(h => (
                      <th key={h} style={{
                        textAlign: h === "Campus" ? "left" : "right", padding: "9px 13px",
                        fontFamily: "Space Grotesk", fontSize: 10.5, fontWeight: 600, letterSpacing: ".1em",
                        textTransform: "uppercase", color: T.faint, whiteSpace: "nowrap",
                      }}>{h}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {[...BRANCHES]
                    .sort((a, b) => (b.passRate.curr - b.passRate.prev) - (a.passRate.curr - a.passRate.prev))
                    .map((b, rank) => {
                      const i = BRANCHES.indexOf(b);
                      const cr = pct(sum(b.fees, f => f.collected), sum(b.fees, f => f.target));
                      const att = pct(b.students.present, b.students.total);
                      const d = b.passRate.curr - b.passRate.prev;
                      const filled = pct(b.admissions.admitted, b.admissions.target);
                      const active = selected === b.id;
                      const medal = ["🥇", "🥈", "🥉"][rank];
                      return (
                        <tr key={b.id} className="vd-row"
                          onClick={() => setSelected(active ? "all" : b.id)}
                          style={{
                            borderBottom: `1px solid ${T.hair}`,
                            background: active ? (dark ? "#1A2B4C" : "#EAF0FE") : "transparent",
                            fontVariantNumeric: "tabular-nums",
                          }}>
                          <td style={{ padding: "11px 13px", textAlign: "right", color: T.faint, width: 40 }}>{medal || rank + 1}</td>
                          <td style={{ padding: "11px 13px", fontWeight: 700, color: T.ink, whiteSpace: "nowrap" }}>
                            <span style={{ display: "inline-block", width: 8, height: 8, borderRadius: 99, background: BRANCH_COLORS[i], marginRight: 8 }} />
                            {b.name}
                          </td>
                          <td style={{ padding: "11px 13px", textAlign: "right", color: T.text }}>{num(b.students.total)}</td>
                          <td style={{ padding: "11px 13px", textAlign: "right", color: att < 91 ? ACC.amber : T.text, fontWeight: att < 91 ? 700 : 400 }}>{att}%</td>
                          <td style={{ padding: "11px 13px", textAlign: "right", color: T.text }}>{inr(b.revenueYTD)}</td>
                          <td style={{ padding: "11px 13px", textAlign: "right", color: cr < 80 ? ACC.red : T.text, fontWeight: cr < 80 ? 700 : 400 }}>{cr}%</td>
                          <td style={{ padding: "11px 13px", textAlign: "right", color: d >= 0 ? ACC.green : ACC.red, fontWeight: 700 }}>
                            {d >= 0 ? "+" : ""}{d.toFixed(1)}
                          </td>
                          <td style={{ padding: "11px 13px", textAlign: "right", color: filled < 75 ? ACC.amber : T.text, fontWeight: filled < 75 ? 700 : 400 }}>{filled}%</td>
                        </tr>
                      );
                    })}
                </tbody>
              </table>
            </div>
            <div style={{ padding: "10px 22px 15px", fontSize: 11.5, color: T.faint }}>
              Tap a row to focus the entire dashboard on that campus · tap again to return to the group view.
            </div>
          </Card>
        </section>

        {/* ── Alerts ── */}
        <section className="vd-fade" style={{ marginTop: 14, animationDelay: ".25s" }}>
          <Card T={T}>
            <SectionTitle T={T} eyebrow="Needs attention" title="Management alerts"
              right={
                <span style={{
                  fontFamily: "Space Grotesk", fontWeight: 700, fontSize: 13.5, color: "#fff",
                  background: alerts.length ? `linear-gradient(135deg, ${ACC.red}, #C2372B)` : `linear-gradient(135deg, ${ACC.green}, ${ACC.teal})`,
                  borderRadius: 999, minWidth: 28, height: 28, display: "inline-flex",
                  alignItems: "center", justifyContent: "center", padding: "0 10px",
                }}>{alerts.length}</span>
              } />
            <div style={{
              marginTop: 15, display: "grid", gap: 10,
              gridTemplateColumns: "repeat(auto-fill, minmax(290px, 1fr))",
            }}>
              {alerts.length === 0 && (
                <div style={{ fontSize: 13.5, color: T.muted, background: "rgba(34,181,115,.12)", borderRadius: 12, padding: "13px 15px" }}>
                  All clear — every tracked metric is within its healthy range for this view.
                </div>
              )}
              {alerts.map((a, i) => {
                const col = a.tone === "red" ? ACC.red : ACC.amber;
                const Icon = a.icon;
                return (
                  <div key={i} style={{
                    display: "flex", gap: 11, alignItems: "flex-start",
                    background: a.tone === "red" ? "rgba(239,90,76,.10)" : "rgba(233,162,59,.10)",
                    border: `1px solid ${col}33`, borderLeft: `3px solid ${col}`,
                    borderRadius: 12, padding: "11px 13px",
                  }}>
                    <div style={{
                      width: 30, height: 30, borderRadius: 9, flexShrink: 0,
                      display: "grid", placeItems: "center", background: `${col}22`, color: col,
                    }}>
                      <Icon size={15} />
                    </div>
                    <div style={{ fontSize: 12.5, lineHeight: 1.5 }}>
                      <strong style={{ color: T.ink }}>{a.branch}.</strong>{" "}
                      <span style={{ color: T.text }}>{a.text}</span>
                    </div>
                  </div>
                );
              })}
            </div>
          </Card>
        </section>

        <footer style={{
          marginTop: 24, fontSize: 11.5, color: T.faint,
          display: "flex", justifyContent: "space-between", flexWrap: "wrap", gap: 8,
        }}>
          <span>Attendance from morning roll call · Finance from fee ledger · Academics from board results</span>
          <span>Vidyarna Group · Board dashboard v3.0</span>
        </footer>
      </main>
    </div>
  );
}